"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var SearchVacanciesContext_1 = __importDefault(require("../context/SearchVacanciesContext"));
var useShowVacancy = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var isBookmarkedPage = !!(0, react_router_dom_1.useMatch)('saved-vacancies/*');
    var providedQuery = (0, react_1.useContext)(SearchVacanciesContext_1.default).providedQuery;
    var showVacancy = function (vacancyId, vacancySlug) {
        if (isBookmarkedPage) {
            navigate("/saved-vacancies/".concat(vacancyId, "/").concat(vacancySlug));
        }
        else {
            navigate("/vacancies/show/".concat(vacancyId, "/").concat(vacancySlug, "?").concat(providedQuery));
        }
    };
    return showVacancy;
};
exports.default = useShowVacancy;
